import AnimalClass, { AnimalCounter, AnimalMother } from './animalClass';
import * as AnimalConstants from './animalConstants';
import AnimalInterface from './animalInterface';
import AnimalService from './animalService';

export { AnimalClass, AnimalConstants, AnimalCounter, AnimalMother };
export type { AnimalInterface };
export default AnimalService;
